import { CampaignCreatePage } from "@/features/campaign/pages/CampaignCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/campaign/create")({
	validateSearch: (search: Record<string, unknown>): { from?: string } =>
		typeof search.from === "string" ? { from: search.from } : {},
	component: RouteComponent,
});

function RouteComponent() {
	const { from } = Route.useSearch();
	return <CampaignCreatePage duplicateOf={from} />;
}
